import api from 'api';
import { Moment } from 'moment';
import { useCallback, useEffect, useState } from 'react';
import './heatmap.scss';
import { useDispatch } from 'react-redux';
import { actions } from 'redux/reducers';
import { ClipType } from 'types';
import moment from 'moment';

function Heatmap({
    projectId,
    dateFrom,
    dateTo,
    streamIds,
    clips
} : {
    projectId: number,
    dateFrom: Moment,
    dateTo: Moment,
    streamIds: number[],
    clips?: any[],
}) {
    const dispatch = useDispatch();
    const hours = ['12a', '1a', '2a', '3a', '4a', '5a', '6a', '7a', '8a', '9a', '10a', '11a', '12p', '1p', '2p', '3p', '4p', '5p', '6p', '7p', '8p', '9p', '10p', '11p'];
    const [data, setData] = useState<{ Count: number, Color: string, Date: Date }[]>([]);
    const [yAxis, setYAxis] = useState<string[]>([]);

    const getHeatmap = useCallback(async () => {
        const heatmapData = await api.heatmap.getAll(projectId, dateFrom, dateTo, streamIds);
        setData(heatmapData.Data);
    }, [dateFrom, dateTo, streamIds, projectId]);

    const onClick = async (date: Date, count: number, e: any) => {
        e.stopPropagation();
        const diff = dateTo.diff(dateFrom, 'days');
        let clips: ClipType[] = [];

        if (count) {
            dispatch(actions.clipTray.set({
                open: true,
                clips: [],
                loading: true
            }))
            if (diff <= 31) {
                clips = await api.clip.getAll(projectId, moment(date), moment(date).clone().add(1, 'h'), streamIds.join(","));
            } else if (diff > 31 && diff <= 90) {
                clips = await api.clip.getAll(projectId, moment(date), moment(moment(date).clone().add(7, 'days').format("D MMM yyyy")), streamIds.join(","));
                clips = clips.filter(x => moment(x.DatePosted).hour() === moment(date).hour());
            } else {
                clips = await api.clip.getAll(projectId, moment(moment(date).startOf('month').format("D MMM yyyy")), moment(moment(date).endOf('month').format("D MMM yyyy")), streamIds.join(","));
                clips = clips.filter(x => moment(x.DatePosted).hour() === moment(date).hour());
            }
            
            dispatch(actions.clipTray.set({
                open: true,
                clips: clips,
                loading: false
            }))
        }
    }

    useEffect(() => {
        const diff = dateTo.diff(dateFrom, 'days');
        const startDate = dateTo.clone();
        let arr = [];

        if (diff <= 31) {
            while (startDate.isSameOrAfter(dateFrom)) {
                arr.push(startDate.format("ddd DD MMM"));
                startDate.subtract(1, 'day');
            }
        } else if (diff > 31 && diff <= 90) {
            while (startDate.isSameOrAfter(dateFrom)) {
                arr.push(`${startDate.clone().subtract(6, 'days').format("DD MMM")} - ${startDate.format("DD MMM YYYY")}`);
                startDate.subtract(1, 'week');
            }
        } else {
            while (startDate.isSameOrAfter(dateFrom)) {
                arr.push(`${startDate.format("MMM YYYY")}`);
                startDate.subtract(1, 'month');
            }
        }
        setYAxis(arr);
    }, [dateFrom, dateTo])

    useEffect(() => {
        getHeatmap();
    }, [getHeatmap])

    return (
        <div className="heatmap">
            <div className="top">
                <p>Hourly Mentions</p>
            </div>
            <div className="body">
                <div className="left">
                    {yAxis.map((x: string, i: number) => <span className="y-axis-item" key={i}>{x}</span>)}
                </div>
                <div className="right">
                    <div className="x-axis">
                        {hours.map((x: string, i: number) => <span className="x-axis-item" key={i}>{x}</span>)}
                    </div>
                    <div className="blocks">
                        {data.map((x: { Count: number, Color: string, Date: Date }, i: number) => {
                            return (
                                <span 
                                    className={`block ${x.Count === 0 ? 'empty' : ''}`}
                                    key={i}
                                    style={{backgroundColor: x.Color}}
                                    onClick={e => onClick(x.Date, x.Count, e)}
                                >
                                    {x.Count}
                                </span>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Heatmap;